module.exports={render:function (){var _vm=this;
  return _vm._h('div', [_vm._m(0), " ", _vm._h('div', {
    staticClass: "main-page",
    staticStyle: {
      "padding-bottom": "0"
    }
  }, [_vm._h('div', {
    staticClass: "bg-white"
  }, [_vm._m(1), " ", _vm._h('div', {
    staticClass: "liner"
  }), " ", _vm._h('div', [_vm._h('p', {
    staticClass: "margin-x-15 padding-15 gray"
  }, ["点击购买按钮，家长将收到保单信息，家长完成购买和支付过程，产生的保单费用20元须返还给家长或从托管费用中除"]), " ", (_vm.isChecked) ? _vm._h('div', {
    staticClass: "margin-x-15 padding-15"
  }, [_vm._h('span', {
    staticClass: "button button-block button-primary button-rounded disabled"
  }, ["给孩子买一份安全保障"])]) : [_vm._h('div', {
    staticClass: "insurance text-center"
  }, [_vm._h('mt-checklist', {
    attrs: {
      "value": _vm.isAgree,
      "options": ['我已阅读并同意相关条款']
    }
  })]), " ", _vm._h('div', {
    staticClass: "margin-x-15 padding-15"
  }, [_vm._h('span', {
    staticClass: "button button-block button-primary button-rounded",
    on: {
      "click": function($event) {
        _vm.checkAgree()
      }
    }
  }, ["给孩子买一份安全保障"])])], " "])]), " "]), " ", _vm._h('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isHideInsertInsure),
      expression: "!isHideInsertInsure"
    }],
    staticClass: "maskdiv"
  }, [_vm._h('div', {
    staticClass: "popover"
  }, [_vm._h('div', {
    staticClass: "pop-wrap text-center"
  }, [_vm._h('p', {
    staticClass: "margin-15"
  }, ["给孩子买一份安全保障"]), " ", _vm._h('div', {
    staticClass: "liner margin-15"
  }), " ", _vm._h('div', {
    staticClass: "clearfix"
  }, [_vm._h('div', {
    staticClass: "col-xs-6 blue"
  }, [_vm._h('a', {
    staticClass: "blue  block",
    staticStyle: {
      "border-right": "1px solid #ddd"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.insertInsureGl()
      }
    }
  }, ["确定"])]), " ", _vm._h('div', {
    staticClass: "col-xs-6 blue"
  }, [_vm._h('a', {
    staticClass: "blue",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.isHideInsertInsure = true
      }
    }
  }, ["取消"])])])])])])])
},staticRenderFns: [function (){var _vm=this;
  return _vm._h('div', {
    staticClass: "topbar"
  }, [_vm._h('div', {
    staticClass: "clearfix main-wrap"
  }, [_vm._h('a', {
    staticClass: "pull-left img-back",
    attrs: {
      "href": "javascript:window.history.go(-1)"
    }
  }, ["返回"]), " ", _vm._h('h1', ["保险说明"])]), " ", _vm._h('div', {
    staticClass: "liner"
  })])
},function (){var _vm=this;
  return _vm._h('div', {
    staticClass: "padding-15"
  }, [_vm._h('p', {
    staticClass: "margin-15"
  }, ["这是一段很长很长的保险说明，不要管我内容是什么，占个坑而已啦。这是一段很长很长的保险说明，不要管我内容是什么，占个坑而已啦。这是一段很长很长的保险说明，不要管我内容是什么，占个坑而已啦。这是一段很长很长的保险说明，不要管我内容是什么，占个坑而已啦。这是一段很长很长的保险说明，不要管我内容是什么，占个坑而已啦。这是一段很长很长的保险说明，不要管我内容是什么，占个坑而已啦。这是一段很长很长的保险说明，不要管我内容是什么，占个坑而已啦。这是一段很长很长的保险说明，不要管我内容是什么，占个坑而已啦。这是一段很长很长的保险说明，不要管我内容是什么，占个坑而已啦。"]), " ", _vm._h('p', {
    staticClass: "margin-15"
  }, ["这是一段很长很长的保险说明，不要管我内容是什么，占个坑而已啦。这是一段很长很长的保险说明，不要管我内容是什么，占个坑而已啦。这是一段很长很长的保险说明，不要管我内容是什么，占个坑而已啦。这是一段很长很长的保险说明，不要管我内容是什么，占个坑而已啦。这是一段很长很长的保险说明，不要管我内容是什么，占个坑而已啦。这是一段很长很长的保险说明，不要管我内容是什么，占个坑而已啦。这是一段很长很长的保险说明，不要管我内容是什么，占个坑而已啦。这是一段很长很长的保险说明，不要管我内容是什么，占个坑而已啦。这是一段很长很长的保险说明，不要管我内容是什么，占个坑而已啦。"]), " ", _vm._h('p', {
    staticClass: "margin-15"
  }, ["这是一段很长很长的保险说明，不要管我内容是什么，占个坑而已啦。这是一段很长很长的保险说明，不要管我内容是什么，占个坑而已啦。这是一段很长很长的保险说明，不要管我内容是什么，占个坑而已啦。这是一段很长很长的保险说明，不要管我内容是什么，占个坑而已啦。这是一段很长很长的保险说明，不要管我内容是什么，占个坑而已啦。这是一段很长很长的保险说明，不要管我内容是什么，占个坑而已啦。这是一段很长很长的保险说明，不要管我内容是什么，占个坑而已啦。这是一段很长很长的保险说明，不要管我内容是什么，占个坑而已啦。这是一段很长很长的保险说明，不要管我内容是什么，占个坑而已啦。"])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.1@vue-loader/lib/template-compiler.js?id=data-v-757b82dd!./~/.10.0.1@vue-loader/lib/selector.js?type=template&index=0!./src/views/insurance/Insurance.vue
// module id = 215
// module chunks = 1